import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import UnreturnedRefundOfRefundsViewModel from "../../../viewModels/finance/unreturnedRefundsOfRefunds/unreturnedRefundOfRefundsViewModel";
import { observer } from "mobx-react-lite";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import Button from "@edaz/edazkit/Button/index";
import React from "react";

const UnreturnedRefundsOfRefundsView: ViewComponent<UnreturnedRefundOfRefundsViewModel> = observer(({ vm }) => {
  return (
    <>
      <h3>{vm.name}</h3>
      <div className="border rounded py-5 py-md-6 py-lg-8 text-center">
        <Icon icon={IconType.Excel} width={64} height={64} />
        <h5 className="mt-4">{vm.translate("description")}</h5>
        <Button
          iconLeft={vm.busyWatcher.isBusy ? IconType.Spinner : IconType.Download}
          onClick={vm.onDownloadClick}
          className="rounded"
          disabled={vm.busyWatcher.isBusy}>
          {vm.translate("downloadFile")}
        </Button>
      </div>
    </>
  );
});

registerView(UnreturnedRefundsOfRefundsView, UnreturnedRefundOfRefundsViewModel);
export default UnreturnedRefundsOfRefundsView;
